import React from 'react';
import { Location } from 'history';
import { Switch, Route, Redirect } from 'react-router';
import AuthorizedLayout from '../layouts/auth/AuthorizedLayout';
import {
    ExamApplicationsListPage,
    ProfilePage,
    NotFoundPage,
    EditExamPage,
    ExamListPage,
    ExamExpertsPage,
    ApplicantsPage,
    ApplicantExamDetailPage,
    ApplicantDetailsPage,
    EcExpertsPage,
    ExpertPage,
    AccountConfirmationPage,
    ExamDetailsPage,
    EmailConfirmationPage,
    NewExamEditExpertsPage,
    ExamDraftPage,
    QecListPage,
    EcDetailsPage,
    ExamWithPaymentPage,
} from '../pages';
import { ErrorBoundary } from 'components';

interface AuthorizedHandlerProps {
    location: Location;
}

const AuthorizedHandler = (props: AuthorizedHandlerProps) => {
    const { location } = props;
    return (
        <AuthorizedLayout location={location}>
            <React.Suspense fallback={<div>Loading...</div>}>
                <ErrorBoundary>
                    <Switch location={location}>
                        <Route path="/my-profile" component={ProfilePage} />
                        <Route path="/new-exam/edit-expert" component={NewExamEditExpertsPage} />
                        <Route path="/new-exam" component={EditExamPage} />
                        <Route path="/exam-experts/:id/experts/:qualifId" component={ExamExpertsPage} />
                        <Route path="/exam-list" component={ExamListPage} />
                        <Route path="/exam-applications" component={ExamApplicationsListPage} />
                        <Route path="/exam-draft/:examApplicationId?" component={ExamDraftPage} />
                        <Route path="/ec-experts" component={EcExpertsPage} />
                        <Route path="/ec-details" component={EcDetailsPage} />
                        <Route path="/qec-list" component={QecListPage} />
                        <Route exact path="/expert/:id" component={ExpertPage} />
                        <Route path="/applicants" component={ApplicantsPage} />
                        <Route exact path="/applicant-details/exam/:examId/:examApplicationId/:tab" component={ApplicantExamDetailPage} />
                        <Redirect path="/applicant-details/exam/:examId/:examApplicationId/" to="/applicant-details/exam/:examId/:examApplicationId/exam-details" />
                        <Route exact path="/applicant-details/:id/:tab" component={ApplicantDetailsPage} />
                        <Route path="/confirm/:token" component={AccountConfirmationPage} />
                        <Route exact path="/exam-with-payment" component={ExamWithPaymentPage} />
                        <Route path="/exam/:examId" component={ExamDetailsPage} />
                        <Route path="/confirm-email/:token/" component={EmailConfirmationPage} />
                        <Route component={NotFoundPage} />
                    </Switch>
                </ErrorBoundary>
            </React.Suspense>
        </AuthorizedLayout>
    );
};

export default AuthorizedHandler;
